import { cn, segmentItem, segmentTrack } from '@shh/ui';
import { NavLink } from 'react-router';
import { rememberFoodTab } from '../../lib/foodTab';
import { useLens } from '../../app/lens';
import { ideasText } from '../../i18n/ideas';
import { mealsText } from '../../i18n/meals';
import { recipesText as t } from '../../i18n/recipes';
import { usePlan } from '../Plus';

/**
 * The tabs inside "Essen" (1.21, Navigationsplan Mike 15.10.): one question per tab, and a tab
 * only appears once it exists – Heute · Woche · Rezepte · Einkauf since Küche 4 (1.22).
 */
const TODAY = { to: '/essen/heute', label: ideasText.tab, end: true };
const WEEK = { to: '/essen/woche', label: mealsText.tab, end: true };
const TABS = [
  { to: '/essen/rezepte', label: t.tabs.recipes, end: false },
  { to: '/essen', label: t.tabs.shopping, end: true },
];

/** The first tab this person sees – where "Essen" opens before anything was chosen. */
export function useFirstFoodTab() {
  const plan = usePlan();
  const lens = useLens();
  return plan.plus || lens.canParent ? TODAY.to : TABS[0]!.to;
}

export function FoodTabs() {
  const plan = usePlan();
  const lens = useLens();
  // "Heute" and "Woche" are Plus: parents see what they would do; kids never see a lock
  // (Konzept 14.10.)
  const tabs = plan.plus || lens.canParent ? [TODAY, WEEK, ...TABS] : TABS;
  return (
    <nav
      aria-label={t.tabsLabel}
      // the same switch as the calendar's views (Mike, 19.10.: "einheitlich verwendet")
      className={cn(segmentTrack, 'self-stretch sm:max-w-md')}
    >
      {tabs.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.end}
          // at once: the next page loads lazily, a quick tap elsewhere must not lose the choice
          onClick={() => rememberFoodTab(tab.to)}
          className={({ isActive }) => segmentItem(isActive)}
        >
          {tab.label}
        </NavLink>
      ))}
    </nav>
  );
}
